import { IS_NEW_LINEUP_UI_ENABLED } from 'utils/env.utils';

import { PerformerFragment } from 'types/api/dato-operations.types';

type Props = {
  index: number;
  performers: Array<PerformerFragment>;
  performer: PerformerFragment;
};

export const formatInitialsName = (name: string) => {
  // Remove any characters that are not letters or spaces
  const cleanedName = name.replace(/[^a-zA-Z\s]/g, '');

  const initials = cleanedName
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, 3)
    .join('');
  return initials;
};

export const formatListOfNames = ({ index, performers, performer }: Props) => {
  let transformNamesToList = '';

  if (index < 3) {
    transformNamesToList += `${performer.name}`;
  }
  if (index < 3 && index != performers.length - 1) {
    transformNamesToList += ', ';
  }
  if (index === 3 && performers.length >= 4) {
    transformNamesToList += ` and more...`;
  }
  return transformNamesToList;
};

export const getPerformersCount = (
  mdlbeastLineupPath: string | undefined,
  performers: Array<PerformerFragment>,
  performersCount: number | undefined,
) => {
  if (!IS_NEW_LINEUP_UI_ENABLED) return performers.length;

  return mdlbeastLineupPath ? performersCount : performers.length;
};

const fallbackPerformers = [
  {
    id: 'unknown',
    name: 'A',
  },
  {
    id: 'unknown1',
    name: 'B',
  },
  {
    id: 'unknown2',
    name: 'J',
  },
  {
    id: 'unknown3',
    name: 'M',
  },
  {
    id: 'unknown4',
    name: 'B',
  },
] as Array<PerformerFragment>;

/**
 * Handles edge cases for lineup data and ensures the UI has something to display.
 *
 * - If `mdlbeastLineupPath` is not provided → returns the given performers as-is.
 * - If `mdlbeastLineupPath` is provided:
 *   - Returns performers if there are more than 3.
 *   - Returns performers plus fallback entries if there are 1–3.
 *   - Returns only fallback entries if performers are empty.
 * - For fallback entries, we are just using the most common initials for artist names
 */
export const getPerformersWithFallback = (
  performers: Array<PerformerFragment>,
  mdlbeastLineupPath: string | undefined,
) => {
  if (!IS_NEW_LINEUP_UI_ENABLED) return performers;

  if (!mdlbeastLineupPath) return performers;

  return performers.length > 3
    ? performers
    : performers.length > 0
      ? [...performers, ...fallbackPerformers]
      : fallbackPerformers;
};
